import { Stack, Box, Typography, Paper } from "@mui/material";
import { blue, grey } from "@mui/material/colors";
import { IIndicator } from "../../../types/molecules";
const Indicator = ({
  color,
  icon,
  label,
  value
}: IIndicator) => {
  const classes = {
    root: {
      width: 1,
      padding: "24px",
      borderRadius: "24px"
    },
    iconContainer: {
      width: 68,
      height: 68,
      backgroundColor: color ?? blue[300],
      borderRadius: "16px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  };
  return <Paper elevation={12} sx={classes.root}>
      <Stack direction={"row"} spacing={2}>
        <Box sx={classes.iconContainer}>{icon}</Box>
        <Box paddingTop={1}>
          <Typography color={grey[600]}>{label}</Typography>
          <Typography variant="h5" fontWeight={700}>
            {value}
          </Typography>
        </Box>
      </Stack>
    </Paper>;
};
export default Indicator;